<template>
     <div class="gamProBarCon">
        <div class="gamUpCon" id="js-gamUpRate" :style="{width: progressWidth}"></div>
    </div>
</template>
<script>
    export default {
        props : {
            total : {
                type : Number,
                default : 0,
            },
            left : {
                type : Number,
                default : 0,
            }
        },
        data() {
            return {
                
            }
        },
        computed: {
            progressWidth(){
                let {total, left} = this
                return left/total*100 + '%'
            }
        },
    }
</script>